import { render, staticRenderFns } from "./PagingComponent.vue?vue&type=template&id=355ae93e&scoped=true"
import script from "./PagingComponent.vue?vue&type=script&lang=js"
export * from "./PagingComponent.vue?vue&type=script&lang=js"
import style0 from "./PagingComponent.vue?vue&type=style&index=0&id=355ae93e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ae93e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355ae93e')) {
      api.createRecord('355ae93e', component.options)
    } else {
      api.reload('355ae93e', component.options)
    }
    module.hot.accept("./PagingComponent.vue?vue&type=template&id=355ae93e&scoped=true", function () {
      api.rerender('355ae93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paging/PagingComponent.vue"
export default component.exports